interface PollingOptions<T> {
    interval?: number; // 轮询间隔时间（毫秒）
    timeout?: number; // 超时时间（毫秒）
    maxAttempts?: number; // 最大尝试次数
    onPolling?: (attempt: number) => void; // 轮询回调
    onQuery?: (result: T) => void; // 查询回调
}

export async function polling<T>(
    task: () => Promise<T>,
    condition: (result: T) => boolean,
    options: PollingOptions<T> = {},
): Promise<T> {
    const { interval = 1000, timeout = 30000, maxAttempts = Infinity, onPolling, onQuery } = options;

    const startTime = Date.now();
    let attempts = 0;

    while (true) {
        // 检查超时
        if (Date.now() - startTime > timeout) {
            throw new Error('轮询超时');
        }

        // 检查尝试次数
        if (attempts >= maxAttempts) {
            throw new Error(`超过最大尝试次数: ${maxAttempts}`);
        }

        attempts++;
        onPolling?.(attempts);

        try {
            const result = await task();

            // 如果满足条件，返回结果
            if (condition(result)) {
                return result;
            }

            onQuery?.(result);

            // 等待下一次轮询
            await new Promise((resolve) => setTimeout(resolve, interval));
        } catch (error) {
            // 如果任务执行失败，继续轮询
            console.warn(`第 ${attempts} 次轮询失败:`, error);
            await new Promise((resolve) => setTimeout(resolve, interval));
        }
    }
}
